function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var size = {
  mobile_min: 320,
  mobile_max: 767,
  tablet_min: 768,
  tablet_max: 1049,
  desktop_min: 1050
}; // Configuration for grid

var gridConfig = {
  grid_size: 12,
  grid_max_width: 1050,
  mobile: {
    grid_outer_spacing: 12,
    column_gap: 16
  },
  tablet: {
    grid_outer_spacing: 24,
    column_gap: 20
  },
  desktop: {
    grid_outer_spacing: 25,
    column_gap: 20
  }
};
var modalConfig = {
  mobileInnerHorizontalPadding: 32,
  tabletInnerHorizontalPadding: 72,
  desktopInnerHorizontalPadding: 40,
  outerVerticalPadding: 105,
  outerHorizontalPadding: 12
}; // Configuration for colors

var colorConfig = {
  primary50: '#D8FAEC',
  primary100: '#02DE82',
  primary300: '#02DE82',
  primary500: '#02DE82',
  primary600: '#21CC7E',
  primary700: '#00AD64',
  white: '#FFFFFF',
  gray50: '#F6F6F6',
  gray100: '#E1E1E1',
  gray200: '#BFBFBF',
  gray500: '#989898',
  gray600: '#7F7F7F',
  gray700: '#404040',
  gray800: '#1F1F1F',
  gray900: '#000000',
  // For backward compatibility
  black: '#000000',
  shadow50: '#0000000F',
  shadow100: '#0000001A',
  shadow500: '#0000009A',
  success: '#02DE82',
  warning: '#E1BC29',
  error: '#BF0E08',
  simplisafeBlue: '#008CC1',
  contrastingBrandColor: '#FFFFFF',
  supplementBrandColor: '#02DE82'
}; // Configuration for default colors of typography types or entire categories

var typographyDefaultColorConfig = {
  allCaps3: 'supplementBrandColor',
  allCaps4: 'gray600'
}; // Configuration for switch

var switchConfig = {
  small: {
    switchTrackWidth: 90,
    switchTrackHeight: 30,
    switchTrackBorderRadius: 15,
    switchThumbSize: 48,
    switchThumbBorderRadius: 24
  },
  large: {
    switchTrackWidth: 120,
    switchTrackHeight: 40,
    switchTrackBorderRadius: 20,
    switchThumbSize: 64,
    switchThumbBorderRadius: 32
  }
}; // Media queries

export var mediaQueryWidthSelectors = {
  mobile: "(max-width: ".concat(size.mobile_max, "px)"),
  tablet: "(min-width: ".concat(size.tablet_min, "px) and (max-width: ").concat(size.tablet_max, "px)"),
  desktop: "(min-width: ".concat(size.desktop_min, "px)")
};
export var deviceMediaQueries = {
  mobile: "@media ".concat(mediaQueryWidthSelectors.mobile),
  mobileAndTablet: "@media ".concat(mediaQueryWidthSelectors.mobile, ", ").concat(mediaQueryWidthSelectors.tablet),
  tablet: "@media ".concat(mediaQueryWidthSelectors.tablet),
  tabletAndDesktop: "@media ".concat(mediaQueryWidthSelectors.tablet, ", ").concat(mediaQueryWidthSelectors.desktop),
  desktop: "@media ".concat(mediaQueryWidthSelectors.desktop),
  allDevices: "@media ".concat(mediaQueryWidthSelectors.mobile, ", ").concat(mediaQueryWidthSelectors.tablet, ", ").concat(mediaQueryWidthSelectors.desktop)
};
var zIndexConfig = {
  tooltip: 1040,
  dropdown: 1050,
  modal: 1060,
  burgerMenu: 1070
};
var mediaQueriesConfig = {
  small: mediaQueryWidthSelectors.mobile,
  medium: mediaQueryWidthSelectors.tablet,
  large: mediaQueryWidthSelectors.desktop
};
var spaceConfig = [0, 4, 8, 16, 32, 64, 128, 256, 512];
var breakpointsConfig = ["".concat(size.tablet_min, "px"), "".concat(size.desktop_min, "px")];

var theme = _objectSpread(_objectSpread({}, gridConfig), {}, {
  switch: switchConfig,
  modal: modalConfig,
  colors: colorConfig,
  typographyDefaultColors: typographyDefaultColorConfig,
  zIndex: zIndexConfig,
  mediaQueries: mediaQueriesConfig,
  fontFamily: "'AkzidenzGroteskBE'",
  breakpoints: breakpointsConfig,
  space: spaceConfig,
  useNeutralColorScheme: false
});

export default theme;